import Shipment from "@/domain/Shipment";

export default class extends Shipment {
    _items;

    get items() {
        return this._items
    }

    set items(value) {
        this._items = value
    }
}